import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class RoleActivator implements CanActivate {
    NeededRole: string = 'User'
    Roles: string = ''
    canActivate(): boolean {
        let _rolesCookieResolver = this.cookieService.get(
            btoa('roles').replace('=', '')
        );
        if ((_rolesCookieResolver != null) && (_rolesCookieResolver.trim() != '')) {
            this.Roles = atob(_rolesCookieResolver);
        }
        console.log(`in guard: ${this.Roles}`)
        if ((this.Roles.trim() == '')) {
            this.router.navigate(['main-page'])
        }
        if ((this.Roles.trim().indexOf(this.NeededRole) == -1)) {
            this.router.navigate(['main-page'])
        }
        return true;
    }
    constructor(private router: Router, private cookieService: CookieService) { }
}

@Injectable()
export class AdminActivator extends RoleActivator {
    NeededRole: string = 'Admin'
}

@Injectable()
export class UserActivator extends RoleActivator {
    NeededRole: string = 'User'
}